// My Skills (Phase 4b) — the employee's competency levels vs target, with gaps.
import { useState, useEffect } from 'react';
import { Target } from 'lucide-react';
import { Card, SectionTitle, CenterSpinner, Pill } from './ui';
import { EmptyState } from './components';
import { AG } from './theme/tokens';
import { api } from './api';

function LevelBar({ level, target }) {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} title={n === target ? 'target' : ''} style={{
          width: 18, height: 8, borderRadius: 3,
          background: n <= level ? AG.primary : AG.n100,
          outline: n === target ? `2px solid ${AG.primary}` : 'none', outlineOffset: 1,
        }} />
      ))}
    </div>
  );
}

export default function MySkills() {
  const [d, setD] = useState(null);
  useEffect(() => { api.myCompetencies().then(setD).catch(() => setD(null)); }, []);
  if (!d) return <CenterSpinner />;

  return (
    <div className="space-y-4 fade-up">
      <SectionTitle title="My Skills" sub="Your competency levels and gaps" />
      {d.count === 0 ? (
        <Card><EmptyState icon={Target} title="No competencies yet" desc="Your competency framework will appear here once defined." /></Card>
      ) : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {[['Competencies', d.count], ['Meeting target', d.metTarget], ['Below target', d.belowTarget], ['Avg gap', d.avgGap]].map(([l, v]) => (
              <Card key={l} style={{ padding: 16 }}><div style={{ fontSize: 22, fontWeight: 700, color: AG.text }}>{v}</div><div style={{ fontSize: 12, color: AG.n500, marginTop: 3 }}>{l}</div></Card>
            ))}
          </div>
          <Card style={{ padding: 18 }}>
            <div style={{ display: 'grid', gap: 10 }}>
              {d.items.map((it) => (
                <div key={it.competencyId} className="flex items-center justify-between" style={{ borderBottom: `1px solid ${AG.divider}`, paddingBottom: 10 }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14, color: AG.text }}>{it.name}</div>
                    <div style={{ fontSize: 12, color: AG.n500 }}>{it.category} · level {it.level} / target {it.target}</div>
                  </div>
                  <div className="flex items-center gap-3">
                    <LevelBar level={it.level} target={it.target} />
                    {it.gap > 0 ? <Pill tone="warning">gap {it.gap}</Pill> : <Pill tone="success">on target</Pill>}
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </>
      )}
    </div>
  );
}
